export interface LocalStorage {
  setItem(key: string, value: string): void;
  getItem(key: string): string | null;
  removeItem(key: string): void;
}

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LocalStorage = Symbol('LocalStorage');
